import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, List, Avatar, Typography, Card, Divider, Space } from "antd";
import {
  UserOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import api from "../../../axiosConfig";

const { Text } = Typography;

function HistorialPacienteDialog({ open, onClose, pacienteId }) {
  const [historial, setHistorial] = useState([]);

  useEffect(() => {
    if (pacienteId && open) {
      // Obtener el historial del paciente
      api
        .get(`/pacientes/historial/${pacienteId}`)
        .then((response) => {
          setHistorial(response.data);
        })
        .catch((error) => {
          console.error("Error al obtener el historial:", error);
          setHistorial([]);
        });
    }
  }, [pacienteId, open]);

  const getIconByAction = (action) => {
    switch (action) {
      case "Creación de Paciente":
        return <UserOutlined style={{ color: "#4CAF50" }} />;
      case "Actualización de Paciente":
        return <CheckCircleOutlined style={{ color: "#FFC107" }} />;
      case "Eliminación de Paciente":
        return <CloseCircleOutlined style={{ color: "#F44336" }} />;
      default:
        return <ClockCircleOutlined style={{ color: "#1976D2" }} />;
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <Text strong style={{ color: "#2E3B4E" }}>
          Historial del Paciente
        </Text>
      }
      footer={null}
      width={800}
      centered
      style={{ borderRadius: "15px" }}
    >
      <div style={{ backgroundColor: "#f9f9f9", padding: "20px" }}>
        <List
          itemLayout="vertical"
          dataSource={historial}
          locale={{ emptyText: 'No hay historial disponible' }}
          renderItem={(registro, index) => (
            <div key={registro.id}>
              <Card
                style={{ borderRadius: "8px", backgroundColor: "#fff" }}
                variant="borderless"
              >
                <List.Item>
                  <Space align="start" size="large">
                    <Avatar style={{ backgroundColor: "#3F51B5" }}>
                      {registro.usuario?.nombre?.charAt(0) || 'U'}
                    </Avatar>
                    <div>
                      <Text
                        strong
                        style={{ color: "#2E3B4E", fontSize: "16px" }}
                      >
                        {`${registro.usuario?.nombre || 'Usuario'} - ${registro.accion}`}
                      </Text>
                      <Text
                        style={{
                          display: "block",
                          marginTop: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        {registro.descripcion}
                      </Text>
                      <Space>
                        {getIconByAction(registro.accion)}
                        <Text type="secondary">
                          {new Date(registro.createdAt).toLocaleString()}
                        </Text>
                      </Space>
                    </div>
                  </Space>
                </List.Item>
              </Card>
              {index < historial.length - 1 && <Divider />}
            </div>
          )}
        />
      </div>
    </Modal>
  );
}

HistorialPacienteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  pacienteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default HistorialPacienteDialog;
